import clsx from "clsx";
import {
  ArrowsPointingInIcon,
  ArrowsPointingOutIcon,
  CalendarDaysIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/outline";

export interface PlanningToolbarProps {
  isHistorical: boolean;
  onToday: () => void;
  settingsBadge?: number;
  onOpenSettings: () => void;
  fullscreen?: boolean;
  onToggleFullscreen?: () => void;
}

export function PlanningToolbar({
  isHistorical,
  onToday,
  settingsBadge = 0,
  onOpenSettings,
  fullscreen,
  onToggleFullscreen,
}: PlanningToolbarProps) {
  return (
    <div className="mp-toolbar" role="toolbar" aria-label="Montageplanung">
      {!isHistorical ? (
        <button
          type="button"
          className="mp-toolbar-btn mp-toolbar-btn--today"
          onClick={onToday}
          title="Zum heutigen Tag springen"
        >
          <CalendarDaysIcon className="mp-toolbar-btn__icon" aria-hidden />
          <span className="mp-toolbar-btn__label">Heute</span>
        </button>
      ) : (
        <span className="mp-toolbar-spacer" />
      )}
      <div className="mp-toolbar-end">
        <button
          type="button"
          className="mp-toolbar-btn mp-toolbar-btn--icon mp-toolbar-btn--settings"
          onClick={onOpenSettings}
          title="Planungseinstellungen"
          aria-label="Planungseinstellungen"
        >
          <Cog6ToothIcon className="mp-toolbar-btn__icon" aria-hidden />
          {settingsBadge > 0 ? (
            <span className="mp-toolbar-btn__badge">{settingsBadge}</span>
          ) : null}
        </button>
        {onToggleFullscreen ? (
          <button
            type="button"
            className={clsx(
              "mp-toolbar-btn mp-toolbar-btn--fullscreen",
              fullscreen && "is-active",
            )}
            onClick={onToggleFullscreen}
            title={
              fullscreen
                ? "Planungsmodus beenden (Esc)"
                : "Planung über volle Seite (Esc zum Beenden)"
            }
            aria-label={fullscreen ? "Planungsmodus beenden" : "Planung über volle Seite"}
            aria-pressed={fullscreen}
          >
            {fullscreen ? (
              <ArrowsPointingInIcon className="mp-toolbar-btn__icon" aria-hidden />
            ) : (
              <ArrowsPointingOutIcon className="mp-toolbar-btn__icon" aria-hidden />
            )}
            <span className="mp-toolbar-btn__label">
              {fullscreen ? "Schließen" : "Vollbild"}
            </span>
          </button>
        ) : null}
      </div>
    </div>
  );
}
